export default {"src":"/_next/static/media/stressMotivationMobile.7de279b0.svg","height":232,"width":272,"blurWidth":0,"blurHeight":0};